import { render, staticRenderFns } from "./PatientNameHeader.vue?vue&type=template&id=328296a6&"
import script from "./PatientNameHeader.vue?vue&type=script&lang=js&"
export * from "./PatientNameHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports